import React from "react";
import { motion } from "framer-motion";
import CustomNavbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";

export default function SkinConcerns() {

  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.8 } }
  };

  const slideUp = {
    hidden: { opacity: 0, y: 60 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  const skinProblems = [
    {
      title: "Acne & Acne Scars",
      text: "Acne occurs due to clogged pores, excess oil production and bacteria. Proper dermatological treatments help reduce acne breakouts and improve acne scars."
    },
    {
      title: "Pigmentation & Dark Spots",
      text: "Pigmentation and dark spots may occur due to sun exposure, hormonal changes or aging. Treatments help restore even skin tone."
    },
    {
      title: "Wrinkles & Fine Lines",
      text: "Aging reduces collagen production leading to wrinkles and fine lines. Anti-aging treatments help rejuvenate and tighten the skin."
    },
    {
      title: "Skin Tags, Moles & Warts",
      text: "These common skin growths are usually harmless but may cause cosmetic concerns. Dermatological procedures safely remove them."
    }
  ];

  const treatments = [
    "Chemical Peeling",
    "Microneedling",
    "Carbon Laser Facial",
    "Anti-Aging Treatment"
  ];

  return (
    <>
      <CustomNavbar />

      <div className="container py-5">

        <motion.h1
          className="text-center mb-4"
          style={{ color: "#9b2226" }}
          variants={fadeIn}
          initial="hidden"
          animate="visible"
        >
          Skin Concerns & Dermatology Treatments
        </motion.h1>

        <p className="text-center mb-5">
          Our clinic provides advanced dermatological treatments for various skin
          concerns using modern technology and medically approved procedures to
          restore healthy and glowing skin.
        </p>

        <h2 className="text-center mb-4">Common Skin Problems We Treat</h2>

        <div className="row g-4">

          {skinProblems.map((item, index) => (
            <div className="col-md-6 col-lg-3" key={index}>
              <motion.div
                className="card h-100 shadow-sm border-0"
                variants={slideUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                whileHover={{
                  scale: 1.06,
                  boxShadow: "0px 15px 30px rgba(0,0,0,0.15)"
                }}
              >
                <div className="card-body text-center">
                  <h3 style={{ color: "#9b2226" }}>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              </motion.div>
            </div>
          ))}

        </div>

        <h2 className="text-center mt-5 mb-4">
          Advanced Skin Treatments Available
        </h2>

        <div className="row g-4">

          {treatments.map((treatment, index) => (
            <div className="col-md-3" key={index}>
              <motion.div
                className="card text-center shadow-sm border-0"
                variants={slideUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                whileHover={{
                  scale: 1.05,
                  boxShadow: "0px 10px 25px rgba(0,0,0,0.15)"
                }}
              >
                <div className="card-body">
                  <h4 style={{ color: "#9b2226" }}>{treatment}</h4>
                </div>
              </motion.div>
            </div>
          ))}

        </div>

      </div>

      <Footer />
    </>
  );
}